import { Array } from "@siteimprove/alfa-array";
import { None } from "@siteimprove/alfa-option";
import { Parser } from "@siteimprove/alfa-parser";
import { Specificity } from "../specificity.js";
import { Selector } from "./selector.js";
import { Simple } from "./simple/index.js";
const { map, oneOrMore } = Parser;
/**
 * {@link https://drafts.csswg.org/selectors/#compound}
 *
 * @public
 */
export class Compound extends Selector {
    static of(...selectors) {
        return new Compound(selectors);
    }
    _selectors;
    _length;
    _key;
    constructor(selectors) {
        super("compound", Specificity.sum(...selectors.map((selector) => selector.specificity)));
        this._selectors = selectors;
        this._length = selectors.length;
        this._key = selectors[0]?.key ?? None;
    }
    get selectors() {
        return this._selectors;
    }
    get length() {
        return this._length;
    }
    matches(element, context) {
        return this._selectors.every((selector) => selector.matches(element, context));
    }
    equals(value) {
        return (value instanceof Compound &&
            Array.equals(value._selectors, this._selectors));
    }
    *[Symbol.iterator]() {
        yield this;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            selectors: this._selectors.map((selector) => selector.toJSON()),
        };
    }
    toString() {
        return this._selectors.map((selector) => selector.toString()).join("");
    }
}
/**
 * @public
 */
(function (Compound) {
    function isCompound(value) {
        return value instanceof Compound;
    }
    Compound.isCompound = isCompound;
    /**
     * {@link https://drafts.csswg.org/selectors/#typedef-compound-selector}
     *
     * @internal
     */
    Compound.parseCompound = (parseSelector) => map(oneOrMore(Simple.parse(parseSelector)), (result) => result.length === 1 ? result[0] : Compound.of(...result));
})(Compound || (Compound = {}));
//# sourceMappingURL=compound.js.map